import { CheckpointStatus, type TimelineCheckpoint } from '../types/experiment.types';

/**
 * Id of the Day 28 "Results Readout" checkpoint on the scripted timeline served
 * by `GET /analytics/experiments/{id}/timeline`.
 *
 * TODO: the wire shape (`AnalyticsTimelineCheckpoint`) carries no semantic
 * `code`/`kind` field, so the readout row can only be recognised positionally.
 * Switch to a backend-provided code if one is ever added.
 */
export const RESULTS_READOUT_CHECKPOINT_ID = 'cp-6';

/** Display name the backend ships for the readout checkpoint; the id fallback. */
const RESULTS_READOUT_NAME = 'results readout';

/**
 * Whether a timeline checkpoint is the Day 28 results readout — the row that
 * carries the readout download actions. Matches on id first, falling back to
 * the checkpoint name so a renumbered script still resolves.
 */
export function isResultsReadoutCheckpoint(checkpoint: TimelineCheckpoint): boolean {
  return (
    checkpoint.id === RESULTS_READOUT_CHECKPOINT_ID ||
    checkpoint.name.trim().toLowerCase() === RESULTS_READOUT_NAME
  );
}

/**
 * Whether the readout artefacts are actually available: the Day 28 checkpoint
 * has to have passed, since the deck and DiD trend are only computed once the
 * full 28-day post-period has data.
 */
export function canDownloadReadout(checkpoint: TimelineCheckpoint): boolean {
  return isResultsReadoutCheckpoint(checkpoint) && checkpoint.status === CheckpointStatus.PASSED;
}
